module.exports = __webpack_public_path__ + "img/China.e0ae0557.png";